export default __webpack_public_path__ + "static/media/performance-on-budget.4e8cfbd3.svg";